import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import OutlinedButton from "../buttons/OutlinedButton";
import Dangerbtn from "../buttons/Dangerbtn";
import { MdCancel } from "react-icons/md";
import PlateformChip from "../discovery/PlateformChip";
import {
  Facebook,
  Forum,
  Instagram,
  Link,
  MoreHoriz,
  People,
  Reddit,
} from "@mui/icons-material";
import BlueButton from "../buttons/BlueButton";
import InputField from "../input/InputField";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface discoveryinterface {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserDiscovery: React.FC<discoveryinterface> = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [otherText, setOtherText] = useState("");
  const [loading, setLoading] = useState(false);

  const options = [
    { label: "Facebook", icon: "./images/social/facebook.png" },
    { label: "Reddit", icon: "./images/social/reddit.png" },
    { label: "Instagram", icon: "./images/social/insta.png" },
    { label: "Google/Bing", icon: "./images/social/bing.png" },
    { label: "Word of Mouth", icon: "./images/social/word_of_mouth.png" },
    { label: "Referral", icon: "./images/social/referral.png" },
    { label: "Other", icon: "./images/social/other.png" },
  ];

  const submitDiscovery = async () => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("uid");
      const howDidYouHear = selectedOption;
      const otherDetails = otherText;

      const response = await axios.post(`${BASE_URL}/user/discovery`, {
        userId,
        howDidYouHear,
        otherDetails,
      });

      handleClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      disableScrollLock={true}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: "-10px",
          margin: "10px",
          maxWidth: "850px",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" className="bg-[#F6F6F6]">
        <div className="flex justify-between">
          <span className="text-[20px] font-bold">
            How Did You Hear About Comicfy?
          </span>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box>
          <div className="mt-6 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {options.map((option) => (
              <PlateformChip
                key={option.label}
                label={option.label}
                icon={option.icon}
                selected={selectedOption === option.label}
                onClick={() => setSelectedOption(option.label)}
              />
            ))}
          </div>
        </Box>
        <div className="mt-4">
          {selectedOption === "Other" && (
            <InputField
              placeholder=""
              label="Please specify"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
            />
          )}
        </div>
      </DialogContent>
      <DialogActions className="border border-t-1">
        <div className="p-2">
          <BlueButton
            label={"Submit"}
            disabled={
              !selectedOption ||
              (otherText.length == 0 && selectedOption === "Other")
            }
            loading={loading}
            onClick={submitDiscovery}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default UserDiscovery;
